module.exports = __webpack_public_path__ + "static/all_day_area_text_behavior-42306b97aa877691030b97fe13d349ed.png";